import { useState } from "react";
import { SectionLabel, Reveal, NC } from "../landing/shared";
import { AccordionItem } from "../landing/Accordion";

const FAQS = [
  ["Is the Better Deal Review™ really free?", "Yes, there's no fee to you for the review. Any lender compensation, points, fees, or closing costs on an actual loan are disclosed through the official lending process."],
  ["Why do I have to complete an application first?", "Because a personalized review needs real, verified information. Without it, anything said would be a guess."],
  ["Will this affect my credit?", "The application includes required authorizations, which may include a credit check. You'll be told exactly what you're authorizing before you authorize it. Watching this replay alone does nothing to your credit."],
  ["What if the honest answer is \u201Cnot yet\u201D?", "Then that's the answer you'll get, along with what would need to change. \u201CPrepare and wait\u201D is a legitimate outcome of this review."],
  ["Do I have to use Josh for my loan?", "No. Completing an application and having the review does not obligate you to work with Shoreline Mortgage Group."],
  ["How long is the replay available?", null],
  ["What happens after I apply?", "Josh reviews the completed information and you schedule your one-on-one Better Deal Review™. A limited number are available after each class because he personally reviews the file."],
  ["What areas do you serve?", "Florida and Pennsylvania."],
];

export default function ReplayFAQ() {
  const [open, setOpen] = useState(-1);
  return (
    <section id="faq" className="py-24 lg:py-36 px-6 lg:px-10" data-testid="replay-faq-section">
      <div className="max-w-4xl mx-auto">
        <Reveal>
          <SectionLabel n="007" text="BEFORE YOU ASK" />
          <h2 className="font-black uppercase text-3xl md:text-4xl tracking-tight mb-12">COMMON QUESTIONS</h2>
        </Reveal>
        <Reveal delay={0.1}>
          <div className="border-t border-[#404653]/40">
            {FAQS.map(([q, a], i) => (
              <AccordionItem
                key={i}
                num={String(i + 1).padStart(2, "0")}
                title={q}
                body={a || (<><NC label="REPLAY_WINDOW" /> from your registration.</>)}
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)}
                testId={`replay-faq-item-${i + 1}`}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
